import React, { useEffect, useState } from 'react'
import useStyles from 'isomorphic-style-loader/useStyles'
import classes from './style.module.scss'
import {Swiper, SwiperSlide} from 'swiper/react'
import { GiftProduct } from '../gift-item'


export const GiftsSwiper = props => {
	const {products, options, isGift} = props
	const initialOpts = {
		slidesPerView: 3.2,
		spaceBetween: 10
	}

	return <Swiper {...initialOpts} {...(options || {})}>
		{
			products && products.map((product, index) => <SwiperSlide key={product.id}>
				<GiftProduct {...props} product={product} position={index + 1}/>
			</SwiperSlide>)
		}
	</Swiper>
}